import axios from '../Common/axios';
import {getAssetCommonCodeList} from '../Common/api';
import {Collapse, Table} from "antd";
import {useState, useEffect} from "react";

function AssetCommonCode__({}) {    
    const [assetTypeDataSource, setAssetTypeDataSource] = useState([]);
    const [assetSpecDataSource, setAssetSpecDataSource] = useState([]);
    const assetTypeColumns = [
        {
            title: 'CODE',
            dataIndex: 'code_cd',
            key: 'code_cd',
            width: '100px',
            align: 'center',
            fixed : 'left',
        },
        {
            title: '코드명',
            dataIndex: 'code_nm',
            key: 'code_nm',
            width: '150px',
            fixed : 'left',
            align: 'left',
        },
        {
            title: '설명',
            dataIndex: 'code_desc',
            key: 'code_desc',
            width: '300px',
            fixed : 'left',
            align: 'left',
        },
    ];

    const assetSpecColumns = [
        {
            title: 'CODE',
            dataIndex: 'code_cd',
            key: 'code_cd',
            width: '100px',
            align: 'center',
            fixed : 'left',
        },
        {
            title: '코드명',
            dataIndex: 'code_nm',
            key: 'code_nm',
            width: '150px',
            fixed : 'left',
            align: 'left',
        },
    ];

    // asset_type, asset_spec
    useEffect(() => {
        const fetchAssetCommonCodes = async () => {
            try{
                const assetTypeResponse = await axios.get(getAssetCommonCodeList("asset_type"));
                // asset_code 데이터 가져오기
                const assetCodeResponse = await axios.get(getAssetCommonCodeList("asset_spec"));

                setAssetTypeDataSource(assetTypeResponse.data);
                setAssetSpecDataSource(assetCodeResponse.data);

                // 두 데이터 합치기
                // setComonCodeDataSource([
                //     ...assetTypeResponse.data,
                //     ...assetCodeResponse.data
                // ]);
            }catch(error){
                console.error("AssetCommonCode.js ------- 자산 공통 코드 로드 실패", error);
            }
        };

        fetchAssetCommonCodes();
    }, []);

    return (
            <div className='layer_overlay' style={{overflowY:'auto', overflowX:'none'}}>
                <table border='0' style={{backgroundColor:'#ffffff'}}>
                <tr style={{fontSize:'12px', fontWeight:'bold', marginLeft:'10px'}}><td align='left'> [ASSET TYPE] </td><td align='left'> [ASSET SPEC] </td></tr>
                <tr><td valign='top'>
                    <Table columns={assetTypeColumns}
                        rowKey={(row) => row.id}
                        dataSource={assetTypeDataSource}
                        pagination={false}
                        bordered size={"small"}
                        >
                    </Table>
                </td><td valign='top'>
                    <Table columns={assetSpecColumns}
                        rowKey={(row) => row.id}
                        dataSource={assetSpecDataSource}
                        pagination={false}
                        bordered size={"small"}
                        >
                    </Table>
                </td></tr>
                </table>
            </div>
    );
}

function AssetCommonCode_({}) {    
    const [assetCodeDataSource, setAssetCodeDataSource] = useState([

        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'centos',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'redhat',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'linux',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'ubuntu',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'freebsd',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'aix',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'hp-ux',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'solaris',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'sunos',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'tru64',  os_type: 'linux'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'stratus',  os_type: '-'},
        {id: 1, asset_type: 'LX',  asset_type_nm: '리눅스 서버',  asset_spec: 'tandem',  os_type: '-'},
        {id: 1, asset_type: 'WS',  asset_type_nm: '윈도우 서버',  asset_spec: 'windows',  os_type: 'windows'},
        {id: 1, asset_type: 'DB',  asset_type_nm: 'DBMS',  asset_spec: 'oracle',  os_type: '택일'},
        {id: 1, asset_type: 'DB',  asset_type_nm: 'DBMS',  asset_spec: 'mysql',  os_type: '택일'},
        {id: 1, asset_type: 'DB',  asset_type_nm: 'DBMS',  asset_spec: 'mariadb',  os_type: '택일'},
        {id: 1, asset_type: 'DB',  asset_type_nm: 'DBMS',  asset_spec: 'postgresql',  os_type: '택일'},
        {id: 1, asset_type: 'DB',  asset_type_nm: 'DBMS',  asset_spec: 'mssql',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'nginx',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'apache',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'resin',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'tomcat',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'webtob',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'jeus',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'jboss',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'jrun',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'weblogic',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'websphere',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'iplanet',  os_type: '택일'},
        {id: 1, asset_type: 'WE',  asset_type_nm: 'WEB',  asset_spec: 'iis',  os_type: '택일'},
        {id: 1, asset_type: 'FW',  asset_type_nm: '정보보호시스템(FW)',  asset_spec: 'firewall',  os_type: '-'},
        {id: 1, asset_type: 'VP',  asset_type_nm: '정보보호시스템(VPN)',  asset_spec: 'vpn',  os_type: '-'},
        {id: 1, asset_type: 'WN',  asset_type_nm: '무선 네트워크',  asset_spec: 'wireless',  os_type: '-'},
        {id: 1, asset_type: 'NW',  asset_type_nm: '네트워크 장비',  asset_spec: 'network',  os_type: '-'},
        {id: 1, asset_type: 'MO',  asset_type_nm: '모바일 앱',  asset_spec: 'android',  os_type: '-'},
        {id: 1, asset_type: 'MO',  asset_type_nm: '모바일 앱',  asset_spec: 'ios',  os_type: '-'},
        {id: 1, asset_type: 'PC',  asset_type_nm: 'PC(Windows)',  asset_spec: 'WindowPc',  os_type: 'windows'},
        {id: 1, asset_type: 'PM',  asset_type_nm: 'PC(Mac)',  asset_spec: 'MacPc',  os_type: 'mac'},
        {id: 1, asset_type: 'WW',  asset_type_nm: 'URL',  asset_spec: 'www',  os_type: '-'},
        {id: 1, asset_type: 'WW',  asset_type_nm: 'URL',  asset_spec: 'webadmin',  os_type: '-'},
        {id: 1, asset_type: 'DD',  asset_type_nm: '정보보호시스템(DDOS)',  asset_spec: 'ddos',  os_type: '-'},
        {id: 1, asset_type: 'DO',  asset_type_nm: '문서',  asset_spec: '문서',  os_type: '-'},
        {id: 1, asset_type: 'FS',  asset_type_nm: '파일서버',  asset_spec: 'fileserver',  os_type: '-'},
        {id: 1, asset_type: 'SE',  asset_type_nm: '물리적 자산',  asset_spec: 'printer',  os_type: '-'},
        {id: 1, asset_type: 'SW',  asset_type_nm: 'Software',  asset_spec: 'esp',  os_type: '-'},
        {id: 1, asset_type: 'CS',  asset_type_nm: '클라우드',  asset_spec: 'kt cloud',  os_type: '-'},
        {id: 1, asset_type: 'CS',  asset_type_nm: '클라우드',  asset_spec: 'naver cloud',  os_type: '-'},
        {id: 1, asset_type: 'CS',  asset_type_nm: '클라우드',  asset_spec: 'nhn cloud',  os_type: '-'},
    ]);

    let rowCount=[];
    const assetCodeDataColumns = [
        {
            title: 'Asset Type',
            dataIndex: 'asset_type',
            key: 'asset_type',
            colSpan:2,
            width: '120px',
            align: 'center',
            fixed : 'left',
            render: (value, row, index) => {
                const obj = { children : value, props : {"rowSpan":0}}
                
                if(index < 0 || value != assetCodeDataSource[index - 1]?.asset_type) {
                    for (
                        let i = 0;
                        index + i != assetCodeDataSource.length &&
                        value == assetCodeDataSource[index + i]?.asset_type;
                        i += 1
                    ) {
                        obj.props.rowSpan = i + 1;
                        rowCount.push(i+1);
                    }

                }
                return obj;
            }
        },
        {
            title: '',
            dataIndex: 'asset_type_nm',
            key: 'asset_type_nm',
            width: '220px',
            fixed : 'left',
            align: 'left',
            colSpan: 0,
            render: (value, row, index) => {
                const obj = { children : value, props : {"rowSpan":0}}
                
                if(index < 0 || value != assetCodeDataSource[index - 1]?.asset_type_nm) {
                    for (
                        let i = 0;
                        index + i != assetCodeDataSource.length &&
                        value == assetCodeDataSource[index + i]?.asset_type_nm;
                        i += 1
                    ) {
                        obj.props.rowSpan = i + 1;
                        rowCount.push(i+1);
                    }
                }
                return obj;
            }
        },
        {
            title: 'Asset Spec',
            dataIndex: 'asset_spec',
            key: 'asset_spec',
            width: '150px',
            fixed : 'left',
            align: 'left',
        },
        {
            title: 'OS Type',
            dataIndex: 'os_type',
            key: 'os_type',
            width: '150px',
            fixed : 'left',
            align: 'left',
        },
    ];

    return (
            <div className='layer_overlay' style={{overflowY:'auto', overflowX:'hidden'}}>
                <table border='0' style={{backgroundColor:'#ffffff'}}>
                    <tr><td align='center' style={{fontSize:'12px', fontWeight:'bold', padding:'10px 0 0 0'}}> 자산 엑셀 파일 입력 코드 </td></tr>
                    <tr><td align='right' style={{fontSize:'9px', fontWeight:'bold', color:'red', paddingRight:'10px'}}> *택일 : linux, unix, windows 중 하나를 선택</td></tr>
                    <tr><td valign='top'>
                        <Table columns={assetCodeDataColumns}
                            rowKey={(row) => row.id}
                            dataSource={assetCodeDataSource}
                            pagination={false}
                            bordered size={"small"}
                        />
                    </td></tr>
                </table>
            </div>
    );
}

function AssetCommonCode({}) {    
    
    const assetOsTypeCon= {"LX":"linux,unix 선택", "WS":"windows", "WE": "택일", "DB":"택일", "MAC":"mac", }
    const [assetCodeDataSource, setAssetCodeDataSource] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchAssetCommonCodes = async () => {
            try{
                const assetTypeResponse = await axios.get(getAssetCommonCodeList("asset_type"));
                // asset_code 데이터 가져오기
                const assetCodeResponse = await axios.get(getAssetCommonCodeList("asset_spec"));

                const assetTypeResponseOrg = assetTypeResponse.data.reduce((acc, item) => {
                    acc[item.code_cd] = item.code_nm;
                    return acc;
                }, {});

                const newData = assetCodeResponse.data.map(item => {
                    return {
                        id: item.id, 
                        asset_type: item.val_01,
                        asset_type_nm: assetTypeResponseOrg[item.val_01],  
                        asset_spec: item.code_cd,  
                        os_type: assetOsTypeCon[item.val_01] || "-"
                    };
                });

                const sortedData = newData.sort((a, b) => {
                    return a.asset_type.localeCompare(b.asset_type);
                });
                
                setAssetCodeDataSource(sortedData);
            }catch(error){
                console.error("AssetCommonCode.js ------- 자산 공통 코드 로드 실패", error);
            }finally{
                setIsLoading(false);
            }   
        };

        fetchAssetCommonCodes();
    }, []);


    let rowCount=[];
    const assetCodeDataColumns = [
        {
            title: '자산 코드(자산 코드 이름)',
            dataIndex: 'asset_type',
            key: 'asset_type',
            colSpan:2,
            width: '120px',
            align: 'center',
            fixed : 'left',
            render: (value, row, index) => {
                const obj = { children : value, props : {"rowSpan":0}}
                
                if(index < 0 || value != assetCodeDataSource[index - 1]?.asset_type) {
                    for (
                        let i = 0;
                        index + i != assetCodeDataSource.length &&
                        value == assetCodeDataSource[index + i]?.asset_type;
                        i += 1
                    ) {
                        obj.props.rowSpan = i + 1;
                        rowCount.push(i+1);
                    }

                }
                return obj;
            }
        },
        {
            title: '자산 코드명',
            dataIndex: 'asset_type_nm',
            key: 'asset_type_nm',
            width: '220px',
            fixed : 'left',
            align: 'left',
            colSpan: 0,
            render: (value, row, index) => {
                const obj = { children : value, props : {"rowSpan":0}}
                
                if(index < 0 || value != assetCodeDataSource[index - 1]?.asset_type_nm) {
                    for (
                        let i = 0;
                        index + i != assetCodeDataSource.length &&
                        value == assetCodeDataSource[index + i]?.asset_type_nm;
                        i += 1
                    ) {
                        obj.props.rowSpan = i + 1;
                        rowCount.push(i+1);
                    }
                }
                return obj;
            }
        },
        {
            title: '자산 유형',
            dataIndex: 'asset_spec',
            key: 'asset_spec',
            width: '150px',
            fixed : 'left',
            align: 'left',
        },
        {
            title: 'OS Type',
            dataIndex: 'os_type',
            key: 'os_type',
            width: '150px',
            fixed : 'left',
            align: 'left',
        },
    ];

    return (
            <div className='layer_overlay' style={{overflowY:'auto', overflowX:'hidden',backgroundColor:'#ffffff'}}>
                <table border='0' style={{backgroundColor:'#ffffff'}}>
                    <tr><td align='center' style={{fontSize:'12px', fontWeight:'bold', padding:'10px 0 0 0'}}> 자산 엑셀 파일 입력 코드 </td></tr>
                    <tr><td align='right' style={{fontSize:'9px', fontWeight:'bold', color:'red', paddingRight:'10px'}}> *택일 : linux, unix, windows 중 하나를 선택</td></tr>
                    <tr><td valign='top'>
                        <Table columns={assetCodeDataColumns}
                            loading={{
                                size: "large",
                                spinning: isLoading
                             }}
                            rowKey={(row) => row.id}
                            dataSource={assetCodeDataSource}
                            pagination={false}
                            bordered size={"small"}
                        />
                    </td></tr>
                </table>
            </div>
    );
}

export default AssetCommonCode;
